export * from "./terms.component";
